module.exports = __webpack_public_path__ + "img/novidades-titulo.0afaf853.png";